import { UAParser } from 'ua-parser-js'
import { ClientCapabilities, ClientType, DeviceType } from '../services/facade'

const mapBrowserName = (browserName?: string): string => {
  if (browserName === 'IE') {
    return 'Internet Explorer'
  } else if (browserName === 'Edge') {
    return 'Microsoft Edge'
  }

  return browserName || ''
}

/**
 * This is mock for DEV env
 * It tries to return the same ClientCapabilities object as we receive from Facade
 */
export function getClientCapabilities(userAgent: string | undefined): ClientCapabilities {
  const parser = new UAParser(userAgent)
  const { version: browserVersion, name: browserName } = parser.getBrowser()
  const { version: osVersion, name: osName = '' } = parser.getOS()
  const { type: deviceType } = parser.getDevice()
  return {
    clientType: ClientType.Browser,
    version: browserVersion || '0',
    majorVersion: parseInt(browserVersion || '0'),
    osGroup: osName,
    os: `${osName} ${osVersion}`,
    deviceType: (deviceType as DeviceType) || DeviceType.Computer,
    browser: mapBrowserName(browserName),
    osVersion,
  }
}
